import { FC } from 'react';
import { Link } from 'react-router-dom';

const Footer: FC = () => {
  return (
    <footer className="footer">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/">
              <img src="/images/dldv_white.svg" alt="DLDV Enterprises" className="h-12 mb-4" />
            </Link>
            <p className="text-sm mt-4">
              DLDV Enterprises BV leverages AI and automation to deliver exceptional marketing and business development services for financial service providers.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-accent-color transition">Home</Link></li>
              <li><Link to="/about" className="hover:text-accent-color transition">About</Link></li>
              <li><Link to="/services" className="hover:text-accent-color transition">Services</Link></li>
              <li><Link to="/ai-automation" className="hover:text-accent-color transition">AI & Automation</Link></li>
              <li><Link to="/contact" className="hover:text-accent-color transition">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><a href="/services#placement-agent" className="hover:text-accent-color transition">Placement Agent</a></li>
              <li><a href="/services#network-introductions" className="hover:text-accent-color transition">Network Introductions</a></li>
              <li><a href="/services#event-hosting" className="hover:text-accent-color transition">Event Hosting</a></li>
              <li><a href="/services#document-creation" className="hover:text-accent-color transition">Document Creation</a></li>
              <li><a href="/services#website-development" className="hover:text-accent-color transition">Website Development</a></li>
              <li><a href="/services#ai-automation-integration" className="hover:text-accent-color transition">AI Integration</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <p className="mb-2">DLDV</p>
            <p className="mb-2">Netherlands</p>
            <p className="mb-2">Email: info@dldv.nl</p>
            <p className="mb-2">Phone: +31 06 37545639</p>
            <p className="mb-4">WhatsApp: +65 81095789</p>
            
            <div className="flex space-x-4 mt-4">
              <a href="https://www.linkedin.com/in/dirkdevlaam/" target="_blank" rel="noopener noreferrer" className="hover:text-accent-color transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} DLDV. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
